<template>
    <!-- 弹窗 -->
    <div class="container">
        <!--<el-collapse-transition>
             <div class="message-box el-dialog" v-show="dialogTableVisible" v-dialogDrag="true" id="message-box">
                <div class="close-box" @click="closeDialog">
                    <i class="el-icon-close"></i>
                </div>
                <el-row class="message-header" id="message-header">
                    <el-col :span="6">
                        <h4 style="background: #1f2d3d;color:#fff;width:100%;padding:8px 0;text-align: center;">消息列表</h4>
                    </el-col>
                    
                </el-row>
                <el-row style="margin-bottom:20px;">
                    <el-col :span="6">
                        <el-input v-model="searchMessage" placeholder="请输入标题或内容" clearable></el-input>
                    </el-col>
                    <el-col :span="6">
                        <el-button style="margin-left:10px;" @click="getNewsList(1)" type="primary">查询</el-button>
                    </el-col>
                    <el-col :span="12" style="text-align: right;">
                        <el-select v-model="messageType" placeholder="请选择" @change="getNewsList(1)">
                            <el-option
                                    v-for="item in messageTypes"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="2"></el-col>
                </el-row>


                <el-table :data="messageList.dataList" stripe max-height="350"  ref="messageTable" @expand-change="messageRemarkRead">

                    <el-table-column type="expand">
                        <template slot-scope="props">
                            <el-form label-position="left" class="demo-table-expand">
                                <el-form-item label="标题：">
                                    <span>{{ props.row.title }}</span>
                                </el-form-item>
                                <el-form-item label="内容：">
                                    <span>{{ props.row.content }}</span>
                                </el-form-item>
                            </el-form>
                        </template>
                    </el-table-column>
                    <el-table-column property="sendUserName" label="发送人"  ></el-table-column>
                    <el-table-column property="receiveUserName" label="接收人" ></el-table-column>
                    <el-table-column property="title" label="标题"></el-table-column>
                    <el-table-column property="readFlag" label="状态" :width="100">
                        <template slot-scope="scope">
                            <span :class="{activeColor:scope.row.readFlag=='N'}">{{showReadStatus(scope.row.readFlag)}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column property="sendTime" label="时间" :formatter="dateFormat" :width="250"></el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <el-button  @click="messageTableExpansion(scope.row)" type="text" size="small">详情</el-button>
                            <el-button  @click="messageTableProcess(scope.row)" type="text" size="small">处理</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div style="width:100%;text-align: center" v-show="messageList.dataList!=false">
                    <el-pagination style="margin-top:10px;"
                                   @current-change="handleCurrentChange"
                                   :page-size="5"
                                   layout="total, prev, pager, next"
                                   :total="messageList.totalCount">
                    </el-pagination>
                </div>
            </div>
            
        </el-collapse-transition> -->
        <el-row class="header" v-if='$wxOpenId'>
            <!-- <el-col :span="2" class="logo" :class="collapsed?'logo-collapse-width':'logo-width'">
                {{collapsed?'':sysName}}
            </el-col>
            <el-col :span="2">
                <div class="tools" @click.prevent="collapse">
                    <i class="fa fa-align-justify"></i>
                </div>
            </el-col> -->
            <!-- <el-col :span="12" v-if="isProd == 'N'">
                <div class="test-tip">
                    <i class="fa fa-exclamation-triangle"></i>系统为体验版本，录入的数据无法完整保存。
                </div>
            </el-col> -->
            <Navi></Navi>
            <div class="userinfo">
                <el-popover placement="right" width="424" trigger="click" v-model="popover" popper-class="popover-db">
                    <div class="db-top">
                        <span :class="msgType == 1 ? 'current' : ''" @click="toMsg(1)">我的待办<span style="color:red"
                                v-if="messageCount">({{ messageCount }})</span></span>
                        <span :class="msgType == 2 ? 'current' : ''" @click="toMsg(2)">抄送我<span style="color:red"
                                v-if="messageCount2">({{ messageCount2 }})</span></span>
                        <i class="el-icon-close" @click="popover = false"
                            style="float: right;margin-top: 14px;font-size: 21px;cursor: pointer;"></i>
                    </div>
                    <div v-if="msgType == 1">
                        <ul v-if="msgList.length" class="infinite-list" v-infinite-scroll="load" v-loading="loading"
                            ref="msg">
                            <li v-for="item in msgList" class="infinite-list-item" @click="$root.gotoDetail(item)">
                                <div class="ft">{{ item.initiatorName }}提交的{{ item.itemName }}</div>
                                <div class="ov">{{ item.bizItemName }}</div>
                                <div>{{ $root.formatDate(item.initiateTime) }}</div>
                            </li>
                            <div style="text-align: center;" v-if="pageCount == pageNo && msgList.length > 6">下面没有数据啦</div>
                        </ul>
                        <div v-else style="text-align: center;">暂无消息</div>
                    </div>
                    <div v-if="msgType == 2">
                        <el-checkbox v-model="isAwait" true-label="Y" false-label="" @change="awaitChange"
                            style="padding-top: 12px;">未读抄送</el-checkbox>
                        <div v-if="msgList2.length" class="infinite-list" v-infinite-scroll="load2" v-loading="loading"
                            ref="msg2">
                            <div v-for="item in msgList2" class="infinite-list-item copy"
                                :class="item.isAwait == 'Y' ? 'unread' : ''" @click="$root.gotoDetail(item)">
                                <div class="ft">{{ item.initiatorName }}提交的{{ item.itemName }}</div>
                                <div class="ov">{{ item.bizItemName }}</div>
                                <div>{{ $root.formatDate(item.initiateTime) }}</div>
                                <div>
                                    <!-- <div v-if="item.processProgress == 'AUDIT_SUBMIT'" class="">提交中</div> -->
                                    <div v-if="item.processProgress == 'AUDIT_WAIT'" class="status" style="color:#e6a23c">
                                        办理中</div>
                                    <div v-if="item.processProgress == 'AUDIT_OK'" class="status" style="color:green">审核通过
                                    </div>
                                    <div v-if="item.processProgress == 'AUDIT_REJECTED'" class="status" style="color:red">
                                        审核不通过</div>
                                </div>
                            </div>
                            <div style="text-align: center;" v-if="pageCount2 == pageNo2 && msgList2.length > 5">下面没有数据啦
                            </div>
                        </div>
                        <div v-else style="text-align: center;">暂无消息</div>
                    </div>

                    <div slot="reference" class="xm-message-box">
                        <i class="el-icon-s-claim" title="我的待办"
                            style="font-size: 18px;position: relative;margin-right: 15px;" @click="toMsg(1)">
                            <abbr v-if="messageCount != 0">{{ messageCount > 99 ? '99+' : messageCount }}</abbr>
                        </i>
                        <span class="cc-pg" title="抄送我" style="font-size: 18px;position: relative;margin-right: 4px;"
                            @click="toMsg(2)">
                            <abbr v-if="messageCount2 != 0">{{ messageCount2 > 99 ? '99+' : messageCount2 }}</abbr>
                        </span>
                    </div>
                </el-popover>
                <!-- <div class="el-dropdown-link xm-message-box" :style="showMessageStyle"
                     @click="dialogTableVisible = !dialogTableVisible;getNewsList(1);">
                     <i class="el-icon-s-claim" style="font-size: 18px;"><abbr v-if="messageCount != 0">{{messageCount > 99 ? '99+': messageCount}}</abbr></i>
                     <span></span>
                     <i class="el-icon--right" v-bind:class="{'el-icon-caret-bottom':dialogTableVisible == false,'el-icon-caret-top':dialogTableVisible == true}"></i>
                </div> -->
                <el-dropdown trigger="hover">
                    <span class="el-dropdown-link userinfo-inner"><i class="el-icon-user-solid"
                            style="font-size: 18px;}"></i> {{ realName }}<i class="el-icon-caret-bottom"></i></span>
                    <el-dropdown-menu slot="dropdown">
                        <!-- <el-dropdown-item>我的消息</el-dropdown-item>-->
                        <el-dropdown-item @click.native="changeUser">切换账号</el-dropdown-item>
                        <el-dropdown-item divided @click.native="toLogout">退出登录</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </el-row>
        <!-- <keep-alive>	
					<router-view v-if="$route.meta.keepAlive"></router-view>
				</keep-alive>
				<router-view v-if="!$route.meta.keepAlive"></router-view> -->
        <router-view :key='key'></router-view>

        <ModalLoginWidget ref='modalLogin' />

    </div>
</template>

<script>
import * as Events from '../helper/Events';
import ModalLoginWidget from '../components/ModalLoginWidget';
import MenuUtils from '@/utils/MenuUtils'
import * as Urls from '../helper/Urls';
import * as VueHelper from '../helper/VueHelper';
import Navi from './Navi';
export default {
    components: {
        ModalLoginWidget, Navi
    },
    data() {
        return {
            nodes: this.$router.options.routes,
            sysName: '新美云平台',
            collapsed: false,
            account: '',
            realName: '',//姓名
            avatarPath: '',
            isProd: '',   //是否是生产环境
            form: {
                name: '',
                region: '',
                date1: '',
                date2: '',
                delivery: false,
                type: [],
                resource: '',
                desc: ''
            },
            // 消息相关
            // messageCount: 0, // 未读消息
            // messageOpacity: 0, // 透明度
            // searchMessage:'',//搜索消息关键字
            // messageType:'',//选中的消息类型
            // messageTypes:[],//消息类型
            // messageList:'',//消息列表
            // messageStatus:'',//消息是否已读
            // pageSize:5,
            // currentPage:1,
            // typeVal: '',
            // dialogTableVisible: false,
            loading: false,
            msgType: 1,
            messageIntval: null,
            messageCount: 0,
            popover: false,
            pageSize: 10,
            pageNo: 1,
            pageCount: 0,
            msgList: [],

            isAwait: 'Y',
            pageNo: 1,
            pageCount2: 0,
            msgList2: [],
            messageCount2: 0,
        }
    },
    created() {

        //这里没有直接使用this.$router.options.routes，是因为addRoute的路由规则，在这里this.$router.options.routes获取不到
        //有兴趣的可以看一下源码，是为什么获取不到，但是却又有规则了
        //另外在开发的时候，可能由于是热部署，也会不断重复的给nodes添加元素，造成导航条有重复的，简单解决，可以设置一个开关
        let inst = this;
        let data = JSON.parse(window.sessionStorage.getItem('userPre'))

        this.nodes = [];
        this.nodes.push(...data)

        // console.log(JSON.stringify(this.nodes))


    },
    methods: {
        toMsg(type) {
            if (type == 1) {
                this.msgType = 1;
                this.pageNo = 1;
                this.getNews();
            } else if (type == 2) {
                this.msgType = 2;
                this.pageNo2 = 1;
                this.isAwait = 'Y';
                this.getCopyNews();
            }

        },
        load() {
            if (this.pageCount > this.pageNo) {
                this.pageNo++;
                this.getNews();
            }
        },
        load2() {
            if (this.pageCount2 > this.pageNo2) {
                this.pageNo2++;
                this.getCopyNews();
            }
        },
        //获取消息列表
        getNews() {
            let inst = this;
            let url = Urls.message_unreadMsgPage;
            let params = {
                pageNo: inst.pageNo,
                pageSize: inst.pageSize
            }
            inst.loading = true;
            inst.$root.doPost(url, params, function (server_data) {
                inst.loading = false;
                if (!inst.$root.isUserLogin(server_data)) {
                    return;
                }
                // 应用错误
                if (server_data.error) {
                    inst.$root.showGlobalError(server_data.error);
                    return;
                };
                inst.pageCount = server_data.data.pageCount;
                if (inst.pageNo == 1) {
                    inst.msgList = server_data.data.dataList;
                    inst.messageCount = server_data.data.totalCount;
                } else {
                    inst.msgList = inst.msgList.concat(server_data.data.dataList);
                }
            }, null, 1)

        },
        //获取未读消息数量
        getUnreadCount() {
            let inst = this;
            let url = Urls.message_unreadMsgCount;
            inst.$root.doPost(url, {}, function (server_data) {
                if (!inst.$root.isUserLogin(server_data)) {
                    return;
                }
                // 应用错误
                if (server_data.error) {
                    inst.$root.showGlobalError(server_data.error);
                    return;
                };
                inst.messageCount = server_data.data;
            }, null, 1)
        },
        //获取抄送消息列表
        getCopyNews() {
            let inst = this;
            let url = Urls.message_unreadCopyMsgPage;
            let params = {
                pageNo: inst.pageNo2,
                pageSize: inst.pageSize,
                isAwait: inst.isAwait
            }
            inst.loading = true;
            inst.$root.doPost(url, params, function (server_data) {
                inst.loading = false;
                if (!inst.$root.isUserLogin(server_data)) {
                    return;
                }
                // 应用错误
                if (server_data.error) {
                    inst.$root.showGlobalError(server_data.error);
                    return;
                };
                inst.pageCount2 = server_data.data.pageCount;
                if (inst.pageNo2 == 1) {
                    inst.msgList2 = server_data.data.dataList;
                    if (inst.isAwait) {
                        inst.messageCount2 = server_data.data.totalCount;
                    }
                } else {
                    inst.msgList2 = inst.msgList2.concat(server_data.data.dataList);
                }
            }, null, 1)

        },
        //获取抄送未读消息数量
        getUnreadCopyCount() {
            let inst = this;
            let url = Urls.message_unreadCopyMsgCount;
            inst.$root.doPost(url, { isAwait: 'Y' }, function (server_data) {
                if (!inst.$root.isUserLogin(server_data)) {
                    return;
                }
                // 应用错误
                if (server_data.error) {
                    inst.$root.showGlobalError(server_data.error);
                    return;
                };
                inst.messageCount2 = server_data.data;
            }, null, 1)
        },
        awaitChange() {
            this.pageNo2 = 1;
            this.getCopyNews();
            if (this.$refs.msg2) {
                this.$refs.msg2.scrollTop = 0;
            }
        },
        //确认退出登录
        toLogout: function () {
            var _this = this;
            this.$confirm('确认退出吗?', '提示', {
                //type: 'warning'
            }).then(() => {
                sessionStorage.removeItem('user');
                sessionStorage.removeItem('userPre');
                _this.loginOut();
            }).catch(() => {

            });


        },
        //退出登录
        loginOut() {
            let inst = this;
            let url = Urls.user_logout;
            let params = {}
            inst.$root.doPost(url, params, function (server_data) {

                if (!inst.$root.isUserLogin(server_data)) {
                    return;
                }
                // 应用错误
                if (server_data.error) {
                    inst.$root.showGlobalError(server_data.error);
                    return;
                };
                inst.$router.push('/login');
                //清除addRouters缓存  
                window.location.reload();
            })

        },
        //切换账号
        changeUser() {
            this.loginOut();
        },
        //折叠导航栏
        collapse: function () {
            this.collapsed = !this.collapsed;
        },
        showMenu(i, status) {
            this.$refs.menuCollapsed.getElementsByClassName('submenu-hook-' + i)[0].style.display = status ? 'block' : 'none';
        },
        // gotoDetail(item){
        //     let path='';
        //     let query={bizItemId:item.bizItemId};
        //     switch(item.itemCat){
        //         case 'LABOR_APPLY':
        //             path = '/common/servicePayDetail'
        //             break;
        //         case 'RISK_ FUND_APPLY':
        //             path = '/common/RiskFundDetails'
        //             break;
        //         case 'ADVANCE_TAX_APPLY':
        //             path = '/common/refundTaxesDetails'
        //             break;
        //         case 'PAID_MATERIAL_APPLY':
        //             path = '/common/materialDetail'
        //             break;
        //         case 'PROPERTY_MANAGEMENT_APPLY':
        //             path = '/common/depositDetail'
        //             break;
        //         case 'BID_BOND_APPLY':
        //             path = '/common/marginDetail'
        //             break;
        //         case 'SEAL_APPLY':
        //             path = '/cm/sealApplicationDetail'
        //             break;
        //         case 'CONTRACT_APPLY':
        //             path = '/cm/contract/read_view0'
        //             break;
        //         case 'GUARANTEE_LETTER_APPLY':
        //             path = '/commonPage/projectManage/guaranteeDetail'
        //             break;
        //         case 'INSURANCE_APPLY':
        //             path = '/finance/insuranceDetail'
        //             break;
        //         case 'PUNISHMENT_APPLY':
        //             path = '/common/adminSanctionDetail'
        //             break;
        //         case 'LITIGATION_APPLY':
        //             path = '/common/litigationDetail'
        //             break;
        //         case 'OTHER_SEAL_APPLY':
        //             path = '/cm/sealApplicationOtherDetail'
        //             break;
        //     }
        //     if(!path)return;
        //     this.popover=false
        //     this.$router.push({ path: path, query: query});
        // },

        // handleCurrentChange: function(currentPage){
        //     this.currentPage = currentPage;
        //     this.getNewsList(currentPage);
        // },
        // closeDialog (currentPage ) {
        //    this.dialogTableVisible = false;
        // },

        // //时间格式化
        // dateFormat:function(row, column) {

        //     var date = row[column.property];

        //     if (date == undefined) {
        //         return "";
        //     }
        //     let d = new Date(date);
        //     return VueHelper.dateTimeFormat(d);
        // },


        // //获取消息框消息类型
        // getNewsType () {
        //     let inst = this;
        //     let url = Urls.message_type;
        //     let params = {};
        //     inst.$root.doPost(url,params,function(server_data) {
        //         if( ! inst.$root.isUserLogin(server_data)){
        //             return;
        //         }
        //         // 应用错误
        //         if(server_data.error){

        //             inst.$root.showGlobalError(server_data.error);
        //             return;
        //         };
        //         inst.messageTypes = server_data.data;
        //     })

        // },
        // //获取消息列表
        // getNewsList (currentPage) {
        //     let inst = this;
        //     let url = Urls.message_list;
        //     let params = {
        //         searchText: inst.searchMessage,
        //         cat: inst.messageType,
        //         pageNo:currentPage ? currentPage:inst.currentPage,
        //         pageSize:inst.pageSize
        //     }
        //     inst.$root.doPost(url,params,function(server_data) {

        //         if( ! inst.$root.isUserLogin(server_data)){
        //             return;
        //         }

        //         // 应用错误
        //         if(server_data.error){
        //             inst.$root.showGlobalError(server_data.error);
        //             return;
        //         };
        //         //传入的currentPage过大，导致没有数据，实际totalCount还有数据
        //         if(server_data.data.totalCount > 0 && server_data.data.dataList.length == 0){
        //             inst.getNewsList (1);
        //         }
        //         inst.messageList = server_data.data;

        //     })

        //     this.getUnreadCount();
        // },
        // //获取未读消息数量
        // getUnreadCount(){
        //     let inst = this;
        //     let url = Urls.message_unread;

        //     inst.$root.doPost(url,{},function(server_data) {

        //         if( ! inst.$root.isUserLogin(server_data)){
        //             return;
        //         }

        //         // 应用错误
        //         if(server_data.error){
        //             inst.$root.showGlobalError(server_data.error);
        //             return;
        //         };

        //         inst.messageCount = server_data.data;
        //     })
        // },
        // //显示消息状态
        // showReadStatus(val){
        //     if(val=='Y'){
        //         return '已读';
        //     }else{
        //         return '未读';
        //     }
        // },
        // //把消息标记为已读
        // messageRemarkRead(item){

        //     let inst = this;
        //     let url = Urls.message_remarkRead
        //     let params = {
        //         cat:item.cat
        //     }
        //     inst.$root.doPost(url,params,function(server_data) {
        //         if( ! inst.$root.isUserLogin(server_data)){
        //             return;
        //         }
        //         // 应用错误
        //         if(server_data.error){
        //             inst.$root.showGlobalError(server_data.error);
        //             return;
        //         };

        //         //把所有该类型的消息全部设置为已读
        //         inst.messageList.dataList.forEach((msg, index) => {
        //             if(msg.cat == item.cat){
        //                 msg.readFlag = 'Y';
        //             }
        //         });
        //         inst.getUnreadCount();
        //     });
        // },
        // //消息表格展开或折叠
        // messageTableExpansion(row){
        //     this.$refs.messageTable.toggleRowExpansion(row);
        // },
        // //消息的处理
        // messageTableProcess(row){
        //     let inst = this;
        //     let cat = row.cat;
        //     let role = row.receiveUserRole;
        //     let isUndefined = false; //未实现

        //     //根据消息类型和角色判断要跳转到哪个页面

        //     if(cat == 'FINANCE_INCOME'){ //财务入账

        //         if(role == 'cm')
        //             inst.$router.push({ path: '/cm/financeIncome/index', query: {}});
        //         else if(role == 'financeManager')
        //             inst.$router.push({ path: '/fm/FMFinanceIncomeIndexView', query: {}});
        //         else
        //             isUndefined = true;

        //     }else if(cat == 'PROJECT_REPORT'){ //项目报备

        //         if(role == 'cmDirector')
        //             inst.$router.push({ path: '/cd/temp_project/index', query: {}});
        //         else
        //             isUndefined = true;

        //     }else if(cat == 'PROJECT_FINISH'){ //在建项目完成

        //         if(role == 'cmDirector')
        //             inst.$router.push({ path: '/cd/project/underConstructionProject', query: {}});
        //         else
        //             isUndefined = true;

        //     }else if(cat == 'CONTRACT_UP'){ //合同上传

        //         if(role == 'cmDirector')
        //             inst.$router.push({ path: '/cd/project/contractList', query: {}});
        //         else if(role == 'financeManager')
        //             inst.$router.push({ path: '/fm/project/contractList', query: {}});
        //         else if(role == 'generalManager')
        //             inst.$router.push({ path: '/gm/project/contractList', query: {}});
        //         else if(role == 'law')
        //             inst.$router.push({ path: '/law/project/contractList', query: {}});
        //         else
        //             isUndefined = true;

        //     }else if(cat == 'MANAGER_APPLY'){//项目总监申请
        //             if(role == 'businessAttache'){
        //                 inst.$router.push({ path: '/ba/pm/projectManagerList', query: {}});
        //             } else if(role == 'businessManager'){
        //                 inst.$router.push({ path: '/bm/pm/projectManagerList', query: {}});
        //             }else if(role == 'cm'){
        //                 inst.$router.push({ path: '/cm/pm/projectManagerList', query: {}});
        //             }else if(role == 'cmDirector'){
        //                 inst.$router.push({ path: '/cd/pm/projectManagerList', query: {}});
        //             }else{
        //                 isUndefined = true;
        //             }
        //     }else if(cat == 'MANAGER_UPDATE'){//修改项目总监
        //             if(role == 'businessManager'){
        //                 inst.$router.push({ path: '/bm/pm/updateApply', query: {}});
        //             }else if(role == 'cmDirector'){
        //                 inst.$router.push({ path: '/cd/pm/updateApply', query: {}});
        //             }else{
        //                 isUndefined = true;
        //             }
        //     }else if(cat == 'MANAGER_INTRODUCER_APPLY'){//项目总监关系申请
        //             if(role == 'cm'){
        //                 inst.$router.push({ path: '/cm/introducer/index', query: {}});
        //             }else if(role == 'cmDirector'){
        //                 inst.$router.push({ path: '/cd/introducer/index', query: {}});
        //             }else{
        //                 isUndefined = true;
        //             }
        //     }else
        //         isUndefined = true;

        //     //当前消息类型或者角色是否未实现跳转功能
        //     if(isUndefined){
        //         inst.$message.error("当前消息类型或者角色未实现跳转功能！");
        //     }else{
        //         inst.dialogTableVisible = false;
        //     }

        //     //标记为已读
        //     this.messageRemarkRead(row);

        // }

    },
    mounted() {

        var user = sessionStorage.getItem('user');
        if (user) {
            user = JSON.parse(user);
            console.log("======", user);
            this.account = user.account || '';
            this.realName = user.realName || '';
            this.avatarPath = user.avatarPath;
            this.isProd = user.isProd;
        }

        // ======== 监听登录事件
        let inst = this;
        this.$root.Bus.$on(Events.GLOBAL_USER_NOT_LOGIN, function () {
            inst.$refs.modalLogin.show();
        });

        //获取消息
        inst.getUnreadCount();
        inst.getUnreadCopyCount();
        inst.messageIntval = setInterval(() => {
            inst.getUnreadCount();
            inst.getUnreadCopyCount();
        }, 1000 * 300)
    },
    computed: {
        key() {
            return this.$route.path + Math.random()
        },
        // TODO:  闪烁效果
        showMessageStyle() {
            let interval = 5; // 5秒
        },
    },
    destroyed() {
        clearInterval(this.messageIntval);
    }
}

</script>

<style scoped lang="scss">
@import '~scss_vars';

.el-dialog {
    position: relative;
    margin: 0;
    background: #fff;
    border-radius: 2px;
    -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, .3);
    box-shadow: 0 1px 3px rgba(0, 0, 0, .3);
    box-sizing: border-box;
    width: 50%;
}

.container {

    .header {
        // background: $color-primary;
        // background: #fff;
        // color: #fff;
        // z-index: 1000;
        // position: absolute;
        // top:20px;
        // right: 0;
        height: 60px;

        .userinfo {
            z-index: 1000;
            position: fixed;
            top: 20px;
            right: 0;
            padding-right: 30px;
            color: #999;

            .userinfo-inner {
                cursor: pointer;
                color: #999;

                img {
                    width: 40px;
                    height: 40px;
                    border-radius: 20px;
                    margin: 10px 0px 10px 10px;
                    float: right;
                }
            }

            // .msg-pg{
            //     background-image: url(../assets/msg.png);
            //     width: 14px;
            //     height: 12px;
            //     display: inline-block;
            //     position: relative;
            //     color: #fff;
            // }
            // .user-pg{
            //     background-image: url(../assets/user.png);
            //     width: 14px;
            //     height: 13px;
            //     display: inline-block;
            // }
            .cc-pg {
                background-image: url(https://xmyun.zhoty.com/resource/xmwebpc/msg-copy-unchecked.png);
                width: 15px;
                height: 15px;
                display: inline-block;
                background-size: contain;

                &:hover {
                    background-image: url(https://xmyun.zhoty.com/resource/xmwebpc/msg-copy-checked.png);
                }
            }
        }

        .logo {
            width: 230px;
            height: 60px;
            font-size: 20px;
            padding-left: 20px;
            padding-right: 20px;
            border-color: rgba(238, 241, 146, 0.3);
            border-right-width: 1px;
            border-right-style: solid;

            img {
                width: 40px;
                float: left;
                margin: 10px 10px 10px 18px;
            }

            .txt {
                color: #fff;
            }
        }

        .logo-width {
            width: 230px;
        }

        .logo-collapse-width {
            width: 60px
        }

        .tools {
            padding: 0px 23px;
            width: 14px;
            height: 60px;
            line-height: 60px;
            cursor: pointer;
        }
    }

    .message-box {
        position: fixed;
        width: 60%;
        overflow: auto;
        background: #fff;
        z-index: 1999;
        top: 80px;
        right: 20px;
        padding: 0 20px;
        padding-bottom: 20px;
        /*background-color:rgb(238, 241, 246)*/
        background-color: #fbfbfb;
    }

    .messageTable {
        width: 100%;
        margin-top: 10px;
        cursor: default;
        border: none;

    }

    tr {
        width: 100%;
        text-align: center;
        height: 40px;
        border: none;
    }

    th {
        color: #909399;
    }

    td {
        color: #606266;
        border: none;

    }

    .activeColor {
        color: red;
    }

    tr:first-child {
        height: 50px;
    }


    .close-box {
        width: 30px;
        height: 30px;
        z-index: 2000;
        position: absolute;
        right: 0px;
        text-align: center;
        line-height: 30px;
        cursor: pointer;

    }
}

.xm-message-box {
    margin-right: 10px;
    cursor: pointer;
    font-size: 19px;

    .el-icon-s-claim:hover {
        color: red
    }
}


span {
    position: relative;
    display: inline-block;
}

abbr {
    position: absolute;
    display: inline-block;
    left: 7px;
    top: -13px;
    background: red;
    width: 25px;
    height: 22px;
    text-align: center;
    line-height: 25px;
    border-radius: 50%;
    font-size: 10px;
    color: #fff;
}

.demo-table-expand {
    font-size: 0;


    .el-form-item {
        margin-right: 0;
        margin-bottom: 0;

        .el-form-item__label {
            width: 90px;
            color: #99a9bf !important;
        }
    }
}

.test-tip {
    color: #c30a0a;
    font-size: 16px;
    white-space: nowrap;
    padding-left: 20px;

    .fa {
        margin-right: 10px;
        color: red;
    }
}
</style>
<style lang="scss">
.popover-db {
    padding-top: 0;
    color: #aaa;

    .db-top {
        background-color: #eee;
        line-height: 50px;
        margin: 0 -12px;
        padding: 0 12px;
        font-size: 16px;
        color: #999;

        >span {
            margin-right: 10px;
            cursor: pointer;
        }

        .current {
            color: #333;
            font-weight: bold;
            border-bottom: solid 2px blue;
        }
    }

    .infinite-list {
        overflow: auto;
        height: 525px;
        list-style: none;
        padding: 0;

        .infinite-list-item {
            border: solid 1px #eee;
            padding: 8px;
            margin-bottom: 10px;
            cursor: pointer;

            &:hover {
                border: solid 1px #1489ec;
            }

            &.copy {
                padding-left: 16px;
                position: relative;
            }

            &.unread::before {
                content: '';
                position: absolute;
                width: 8px;
                height: 8px;
                border-radius: 25px;
                background-color: red;
                top: 14px;
                left: 4px;
            }

            .ft {
                font-size: 16px;
                font-weight: bold;
                color: #333;
            }

            .ov {
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }

            .status {
                position: absolute;
                right: 8px;
                bottom: 8px;
                border: solid 1px;
                padding: 0 3px;
            }

        }
    }

    .popper__arrow::after {
        border-left-color: #eee !important;
    }
}
</style>



// WEBPACK FOOTER //
// HomeView.vue?fffddd20